export default function Contact() {
  const handleContact = () => {
    window.location.href = 'mailto:hello@arafattudio.com';
  };

  return (
    <section id="contact" className="relative py-40 px-6 bg-[#F8F9FB]">
      <div className="max-w-4xl mx-auto text-center">
        <h2
          className="text-6xl md:text-7xl lg:text-8xl font-bold text-black mb-12 leading-tight"
          style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.03em' }}
        >
          Let's build something
          <br />
          meaningful.
        </h2>

        <p
          className="text-xl md:text-2xl text-black/60 mb-16 max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Whether you're launching a new venture or refining an existing product, I'm here to help bring your vision to life.
        </p>

        <button
          onClick={handleContact}
          className="group relative backdrop-blur-xl bg-black border border-black rounded-full px-12 py-5 text-lg font-medium text-white hover:bg-black/90 transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          <span className="relative z-10">Get in Touch</span>
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </button>

        <div className="mt-24 pt-12 border-t border-black/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p
              className="text-sm text-black/40"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              © 2025 Arafat Studio. All rights reserved.
            </p>

            <div className="flex items-center gap-8">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black/40 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a
                href="https://behance.net"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black/40 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-behance-line text-xl"></i>
              </a>
              <a
                href="https://dribbble.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black/40 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-dribbble-line text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black/40 hover:text-black transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>

            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-black/40 hover:text-black transition-colors duration-300 cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
